import SharedFooter from '@/components/share/footer'

export default {
  name: 'grade',
  components: {
    SharedFooter
  },
  computed: {
    env () {
      return this.$store.getters.env
    },
    file () {
      return `${this.env.S3}/enterprise/${this.$route.params.enterpriseId}/smartthon/${this.$route.params.smartthonId}/suggestion/${this.$route.params.studentId}/${this.suggestion.fileName}`
    },
    average () {
      return (Number(this.input[0]) + Number(this.input[1]) + Number(this.input[2]) + Number(this.input[3]) + Number(this.input[4])) / 5
    },
    nameState () {
      return this.input.name.length > 0
    },
    isSignedIn () {
      return this.$store.getters.isSignedIn
    }
  },
  data () {
    return {
      title: '',
      student: {},
      smartthon: {},
      grade: {},
      suggestion: {},
      loading: true,
      share: '',
      isCopied: false,
      isModal: false,
      modalInfo: {},
      updating: false,
      error: {
        flag: false,
        message: ''
      },
      input: {
        name: '',
        0: '選択してください',
        1: '選択してください',
        2: '選択してください',
        3: '選択してください',
        4: '選択してください'
      }
    }
  },
  mounted () {
    this.onInit()
  },
  methods: {
    onInit () {
      this.loading = true

      let pathParams = {
        enterpriseId: this.$route.params.enterpriseId,
        smartthonId: this.$route.params.smartthonId,
        studentId: this.$route.params.studentId
      }

      let additionalParams = {
        queryParams: {
          type: 'review'
        }
      }

      this.$apig.get(this.$store.getters.api.SUGGESTION, pathParams, additionalParams, {}, !this.isSignedIn)
        .then(response => {
          this.title = response.data.suggestion.title
          this.student = response.data.student
          this.smartthon = response.data.smartthon
          this.grade = response.data.grade
          this.suggestion = response.data.suggestion
          this.share = `${this.env.DOMAIN}/review/${this.$route.params.enterpriseId}/${this.$route.params.smartthonId}/${this.$route.params.studentId}`
          this.input = {
            name: '',
            0: '選択してください',
            1: '選択してください',
            2: '選択してください',
            3: '選択してください',
            4: '選択してください'
          }
          this.loading = false
        })
    },
    onCopy () {
      this.isCopied = true
    },
    studentAvatar (item) {
      return `${this.env.S3}/student/avatar/${item.avatarId}.png`
    },
    getIcon (i, score) {
      if (i <= Math.floor(score)) return 'star'
      else if (i > Math.floor(score) && i <= Math.round(score)) return 'star-half-alt'
      else return 'star'
    },
    openModal () {
      this.isModal = true
    },
    sendGrade () {
      this.updating = true

      let pathParams = {
        enterpriseId: this.$route.params.enterpriseId,
        smartthonId: this.$route.params.smartthonId,
        studentId: this.$route.params.studentId
      }

      let additionalParams = {
        queryParams: {
          type: 'grade'
        }
      }

      this.$apig.patch(this.$store.getters.api.SUGGESTION, pathParams, additionalParams, this.input, !this.isSignedIn)
        .then(response => {
          this.updating = false
          this.isModal = false
          window.scrollTo(0, 0)
          this.onInit()
        })
        .catch(err => {
          console.log(err)
          this.error = {
            flag: true,
            message: err.response.data.message
          }
          this.updating = false
        })
    },
    resetModal () {
      this.error = {
        flag: false,
        message: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/review/grade/grade.js